import { Component, Input, Output, EventEmitter } from '@angular/core';

import { UpdatePlanService } from './update-plan.service';

@Component({
  selector: 'update-plan',
  template: require('./update-plan.component.html'),
  styles: [require('./update-plan.component.scss')],
  providers: [UpdatePlanService]
})
export class UpdatePlanComponent {

  @Input()
  set display(toDisplay: boolean) {
    this.service.open(toDisplay);
  }

  @Output() onClose = new EventEmitter<boolean>();
  close() {
    this.service.close();
    this.onClose.emit(true);
  }

  constructor(private service: UpdatePlanService) {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/update-plan/update-plan.component.ts